import React, { useEffect, useState } from 'react'
import MainContentWrapper from '../../Components/MainContentWrapper'
import { PDRL_ADMIN_ROUTES } from '../../routes'
import backgroundImage from '../../assets/adminDashboardBG.png'
import AdminDashboardCard from './AdminDashboardCard.js';
import { useSelector } from 'react-redux';
import cseIcon from "../../assets/cse.svg";
import cseActiveIcon from "../../assets/cseActive.svg";
import financeActiveIcon from "../../assets/financeActive.svg";
import financeIcon from "../../assets/finance.svg";
import marketingIcon from "../../assets/marketing.svg";
import marketingActiveIcon from "../../assets/marketingActive.svg";
import operationsIcon from '../../assets/operations.svg';
import operationsActiveIcon from '../../assets/operationsActive.svg';
import salesIcon from '../../assets/sales.svg';
import salesActiveIcon from '../../assets/salesActive.svg';
import teamsIcon from '../../assets/teams.svg';
import teamsActiveIcon from '../../assets/teamsActive.svg';
import telecallerIcon from '../../assets/telecaller.svg';
import telecallerActive from '../../assets/telecallerActive.svg';
const AdminDashBoard = () => {
    const { user } = useSelector((state) => state.user);
    const date = new Date();
    let formattedDate = `${date.toLocaleString('en-US', { month: 'short' })} ${date.getDate()} ${date.getFullYear()}, ${date.toLocaleString('en-US', { weekday: 'long' })}`;
    useEffect(() => {

        localStorage.setItem('dsp_id', "admin")
        localStorage.removeItem("operationsrequestFilters")
        localStorage.removeItem("UserInvoicesFilters")
        localStorage.removeItem("dspInvoicesFilters")
        localStorage.removeItem("telecallerFilter")
        localStorage.removeItem("Telecaller_overviewData")
        localStorage.removeItem("RequestIssueFilter")
        localStorage.removeItem("notificationHistory")
        localStorage.removeItem("TextnotificationHistory")
        localStorage.removeItem("CRMLeadsFilter")
        localStorage.removeItem("CRMLeadsLogFilter")
        localStorage.removeItem("subscription_invoices_filters")
    }, [])

    const dashboardCards = [
        {
            title: "Finance",
            icon: financeIcon,
            hoverIcon: financeActiveIcon,
            bgImage: require("../../assets/financeBg.png"),
            view: PDRL_ADMIN_ROUTES.FINANCE_DASHBOARD
        },
        {
            title: "Customer Success",
            icon: cseIcon,
            hoverIcon: cseActiveIcon,
            bgImage: require("../../assets/customerSuccessBg.png"),
            view: PDRL_ADMIN_ROUTES.SUCCESS_ENGI_DASHBOARD
        },
        {
            title: "Operations",
            icon: operationsIcon,
            hoverIcon: operationsActiveIcon,
            bgImage: require("../../assets/operationsBg.png"),
            view: PDRL_ADMIN_ROUTES.OPEARTIONSDASHBOARD
        },
        {
            title: "BhuMeet Teams",
            icon: teamsIcon,
            hoverIcon: teamsActiveIcon,
            bgImage: require("../../assets/teamsBg.png"),
            view: PDRL_ADMIN_ROUTES.TEAMS
        },
        {
            title: "Marketing",
            icon: marketingIcon,
            hoverIcon: marketingActiveIcon,
            bgImage: require("../../assets/marketingBg.png"),
            view: PDRL_ADMIN_ROUTES.MARKETINGDASHBOARD
        },
        {
            title: "Sales",
            icon: salesIcon,
            hoverIcon: salesActiveIcon,
            bgImage: require("../../assets/salesBg.png"),
            view: PDRL_ADMIN_ROUTES.SALES_DASHBOARD
        },
        {
            title: "Telecaller",
            icon: telecallerIcon,
            hoverIcon: telecallerActive,
            bgImage: require("../../assets/telecallerBg.png"),
            view: PDRL_ADMIN_ROUTES.TelecallerDashboard
        }
    ];


    return <MainContentWrapper containerStyle={{ padding: "20px 56px" }}>
        <div className="dashboard-first-section-second-div" style={{ width: "100%", overflow: "hidden" }} >
            {/* welcome banner */}
            <div className='w-full relative px-3 mb-4'>
                <span className='absolute top-6 left-7 text-[#102041] font-manrope font-[600] custom-md:text-[24px] text-[18px] '>Welcome back ,{user.name?.split(" ")[0]}</span>
                <img src={backgroundImage} alt="" className='w-full h-full object-cover rounded-[15px]' />
                <div className='bg-[#DDE7FC] custom-md:w-[200px] custom-md:h-[38px] w-[170px] h-[30px]  absolute right-8 top-6 rounded-full flex justify-center items-center'>
                    <span className='font-manrope text-[#0E1D1B] font-[500] custom-md:text-[16px] text-[15px]'>
                        {formattedDate}
                    </span>
                </div>
            </div>

            {/* dashboard cards */}
            <div className='dashboard_cards_wrapper' style={{ overflow: "auto", maxHeight: "70%" }}>
                {dashboardCards.map((card, index) => (
                    <AdminDashboardCard
                        key={index}
                        title={card.title}
                        icon={card.icon}
                        hoverIcon={card.hoverIcon}
                        bgImage={card.bgImage}
                        view={card.view}
                    />
                ))}
            </div>
        </div>
    </MainContentWrapper>
}

export default AdminDashBoard